import { gsap } from "gsap";
import Alpine from "alpinejs";

Alpine.data("facts", () => ({
  init() {
    // console.log('facts init')
  },
  destroy() {
    // console.log('facts destroy')
  }
}));